import { FieldValues, UseFormReturn } from "react-hook-form";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import ReceivingMethodsHeader from "../receiving-methods/ReceivingMethodsHeader";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import { useTranslation } from "@/hooks/localization/useTranslations";
import DeliverySection from "./receiving-methods-popup-helpers/DeliverySection";
import PickupSection from "./receiving-methods-popup-helpers/PickupSection";
import { RecievingFields } from "@/app/components/pages-components/checkout/checkout-helpers/receiving-settings/receiving-settings-helpers/helpers";
import { useAtom } from "jotai";
import { disableSubmitBtnAtom } from "@/hooks/receivingHeaderAtom";
import ReceivingMethodBtns from "../receiving-methods/ReceivingMethodBtns";

interface Props {
  form: UseFormReturn<FieldValues, any>;
  deliveryTimeField: IField;
  pickupTimeField: IField;
  className: string;
  mobile: boolean;
}

const ReceivingMethodsPopUp: React.FC<Props> = ({
  form,
  deliveryTimeField,
  pickupTimeField,
  className,
  mobile,
}) => {
  const t = useTranslation();
  const getCompany = useGetCompanyQuery();
  const shippingSettings = getCompany?.data?.result?.shipping_settings;
  const [disableSubmitBtn] = useAtom(disableSubmitBtnAtom);
  const delivery_methods: DeliveryMethodsTypes[] = [];
  if (shippingSettings?.enable_shipping)
    delivery_methods.push(DeliveryMethodsTypes.delivery);
  if (shippingSettings?.enable_pickup)
    delivery_methods.push(DeliveryMethodsTypes.pickup);
  const currentMethod = form.watch(RecievingFields.recievingFieldName);
  return (
    <>
      <div
        className={className}
        style={{
          border: "none",
          padding: "24px",
        }}
      >
        <ReceivingMethodsHeader
          isPopUp
          deliveryMethods={delivery_methods ?? []}
          mobile={mobile}
        />
        {delivery_methods?.length > 1 && (
          <ReceivingMethodBtns
            form={form}
            recievingFieldName={RecievingFields.recievingFieldName}
            delivery_methods={delivery_methods}
            mobile
          />
        )}
        {currentMethod === DeliveryMethodsTypes.delivery ? (
          <DeliverySection
            enabled={shippingSettings?.enable_shipping!}
            isMobile={mobile}
            addressIdFieldName={RecievingFields.addressIdFieldName}
            timeField={deliveryTimeField}
            form={form}
            shipping_not_available_message={
              shippingSettings?.shipping_not_available_message!
            }
          />
        ) : (
          <PickupSection
            enabled={shippingSettings?.enable_pickup!}
            form={form}
            isMobile={mobile}
            timeField={pickupTimeField}
            pickup_not_available_message={
              shippingSettings?.pickup_not_available_message!
            }
          />
        )}
        <CustomButton
          type={BtnTypes.primary}
          size={BtnSizes.large}
          radius={BtnRadius.small}
          fullWidth
          isSubmit
          disabled={disableSubmitBtn}
          notAllowed={disableSubmitBtn}
        >
          {t.confirm}
        </CustomButton>
        {/* {disableSubmitBtn && (
          <CheckoutErrMsg
            message={
              t.sorry_there_is_no_branch_serving_the_area_you_selected_Please_choose_another_area
            }
          />
        )} */}
      </div>
    </>
  );
};

export default ReceivingMethodsPopUp;
